<template>
    <div class="CoverageFormat">
      <img
        src="/images/Z8J0VnF.png"
        alt="bigbanner-background"
        class="banner-img CoverageFormat__saturation"
      />
  
      <section class="mt-5">
        <nav class="container">
          <ul>
            <li><strong>POPULATION*</strong> - The current population of Chile is 19,416,438.</li>
            <li><strong>NEIGHBOURING COUNTRIES*</strong> - Borders Argentina, Bolivia, and Peru. Strategic sea routes: Magellan Strait, Beagle Channel, and Drake Passage.</li>
            <li><strong>LANGUAGE SPOKEN</strong> - Spanish (specifically Chilean Spanish), spoken by over 14 million people. Indigenous and immigrant languages also present.</li>
            <li><strong>CURRENCY</strong> - Chilean Peso (established in 1925).</li>
            <li><strong>INDUSTRIES</strong> - Agriculture, Mining, Services, Finance, Tourism. Chile is among the most stable and prosperous South American economies.</li>
            <li><strong>TOP 3 CITIES</strong>
              <ul>
                <li>Santiago, Santiago Metropolitan</li>
                <li>Puente Alto, Santiago Metropolitan</li>
                <li>Antofagasta, Antofagasta</li>
              </ul>
            </li>
            <li><strong>WEATHER</strong> - Wide range: desert in the north, Mediterranean center, oceanic south, and cold in the Andes. Opposite seasons to the Northern Hemisphere.</li>
            <li><strong>NATIONAL SPORT</strong> - Rodeo is official, but football is the most popular sport.</li>
          </ul>
  
          <div class="text-center">
            <img
              src="https://gistcdn.githack.com/juan-bits/52e506e7641d322e1dfeabb5876ee78a/raw/7e2a98f9740929ca8884900ba2d5e96c6a5884b1/chile-162264.svg"
              alt="Chile flag"
              class="my-5 CoverageFormat__flag"
              style="width: 150px"
            />
          </div>
        </nav>
  
        <article>
          <p>
            In this elongated South American country you'll discover deserts and glaciers, remote islands and idyllic beaches, as well as a captivating culture. At 4,270 km, Chile is the second longest country in the world.
          </p>
  
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26628236.469558075!2d-106.25013511800232!3d-35.44198946059118!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662c5410425af2f%3A0x505e1131102b91d!2sChile!5e0!3m2!1sen!2ses!4v1653994139991!5m2!1sen!2ses"
            width="95%"
            height="450"
            class="CoverageFormat__margins"
            style="border:0"
            allowfullscreen=""
            loading="lazy"
            title="Chile map"
          ></iframe>
  
          <h4 class="mt-4">Tourism*</h4>
          <p>Chile offers sustainable and inclusive tourism. In 2020, it welcomed over 1M tourists, mostly from South America and Europe.</p>
          <p>Colombians were the top international tourists in 2021, with 36,000+ visitors.</p>
  
          <h4 class="mt-4">Main Ports / Airports</h4>
          <table class="table">
            <thead>
              <tr><th>Rank</th><th>Airport</th><th>IATA</th></tr>
            </thead>
            <tbody>
              <tr><td>1</td><td>Comodoro Arturo Merino Benítez International Airport</td><td>SCL</td></tr>
              <tr><td>2</td><td>Cerro Moreno International Airport</td><td>ANF</td></tr>
              <tr><td>3</td><td>El Tepual Airport</td><td>PMC</td></tr>
            </tbody>
          </table>
  
          <h4>5 Major Ports In Chile</h4>
          <ul>
            <li>Port of Valparaíso</li>
            <li>Port of San Antonio</li>
            <li>Port of Punta Arenas</li>
            <li>Port of Iquique</li>
            <li>Port of Arica</li>
          </ul>
  
          <h4 class="mt-5">Typical Food</h4>
          <p>
            The national dish is Cazuela de Ave — a hearty chicken stew that’s flavorful, comforting, and easy to prepare.
          </p>
  
          <h4 class="mt-5">Employment</h4>
          <p>
            As of March 2022, employment rate reached 54.9%. This measures the working-age population with jobs.
          </p>
        </article>
      </section>
  
      <div class="container">
        <h4 class="my-5">Submarine Cables</h4>
        <a href="https://www.submarinecablemap.com/country/chile" target="_blank" rel="noopener noreferrer">
          <img src="/images/zVj6GNb.png" alt="submarine cables" width="100%" />
        </a>
        <ol class="mt-4">
          <li>Curie</li>
          <li>Fibra Optica Austral</li>
          <li>FOS Quellon-Chacabuco</li>
          <li>Prat</li>
          <li>Segunda FOS Canal de Chacao</li>
          <li>South America-1 (Sam-1)</li>
          <li>South American Crossing (SAC)</li>
          <li>South Pacific Cable System (SPSC)/Mistral</li>
        </ol>
  
        <h4 class="my-4">Access to Landline and Mobile Phone*</h4>
        <p>
          Chile has a competitive and evolving telecom market. LTE is widespread, 5G launched in 2021. Mobile penetration is among the highest in South America.
        </p>
        <p>
          2G/3G is being phased out by 2025. 5G will dominate by 2029. Fixed broadband is growing, while wireline voice continues declining.
        </p>
  
        <h4 class="my-4">Access to Internet*</h4>
        <p>
          Chile’s telecom sector is Latin America’s most advanced. Fibre broadband is expanding rapidly, supported by initiatives like Fibra Óptica Austral.
        </p>
        <p>
          Operators offer bundled services including VOD at competitive prices, which fuels fixed broadband growth.
        </p>
  
        <h4 class="my-4">Our Capabilities</h4>
        <table class="table table-striped mb-5">
          <tbody>
            <tr><td>Dedicated Lines</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Business Broadband</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Wireless Connectivity</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>CPE / Router</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>GEMS</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Diverse Gateway Solutions</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>DDoS</td><td><i class="fas fa-check"></i></td></tr>
          </tbody>
        </table>
  
        <p class="CoverageFormat__tag CoverageFormat__margins text-center" align="justify">
          With our Global Business Solutions team, we can provide a
          <mark>Commercial Offer in 2–3 working days.</mark> Our Global Ops team delivers in Santiago and Valparaíso in 3–4 weeks, other cities in 5–6 weeks.
        </p>
  
        <p class="text-center">
          For more information, <a href="mailto:sales@inte-QT.com?subject=Mail from Our Site">Email Us</a>.
        </p>
  
        <h4>* - References</h4>
        <ul>
          <li><a href="https://www.worldometers.info/world-population/chile-population/" target="_blank" rel="noopener noreferrer">Reference 1</a></li>
          <li><a href="https://globaledge.msu.edu/countries/chile" target="_blank" rel="noopener noreferrer">Reference 2</a></li>
        </ul>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import GetInTouch from '@/components/GetInTouch.vue';
  
  export default {
    name: 'ChilePage',
    components: {
      GetInTouch,
    },
    metaInfo() {
      return {
        title: 'Internet in Chile - inte-QT',
        meta: [
          { name: 'title', content: 'Internet in Chile - inte-QT' },
          { name: 'description', content: 'Our Coverage in Chile' },
        ],
        link: [
          {
            rel: 'canonical',
            href: 'https://www.inte-qt.com/coverage/chile',
          },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
.CoverageFormat {
  color: black;
}

.CoverageFormat__title {
  position: absolute;
  width: 50vw;
  top: 15vh;
  left: 25vw;
  line-height: 1.5;
  font-size: 3rem;
  font-weight: 500; 
  color: #ffffff;  
}

@media (max-width: 992px) {
  .CoverageFormat__title {
    font-size: 3rem;
    width: 40vw;
    top: 30vh;
    left: 55vw;
  }
}

@media (max-width: 768px) {
  .CoverageFormat__title {
    font-size: 2rem;
    width: 40vw;
    top: 25vh;
    left: 55vw;
  }
}

@media (max-width: 576px) {
  .CoverageFormat__title {
    top: 12vh;
    left: 5vw;
    width: 90vw;
    font-size: 1.5rem;
  }
}

.CoverageFormat__tag {
  font-size: 1.5rem;
}

.CoverageFormat section {
  display: -webkit-flex;
  display: flex;
}

.CoverageFormat nav {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.CoverageFormat nav ul {
  padding: 0;
}

.CoverageFormat ul li,
.CoverageFormat ol li {
  margin: 1rem;
  text-align: left;
}

.CoverageFormat article {
  color: black;
  -webkit-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding: 10px;
}

.CoverageFormat__saturation {
  filter: drop-shadow(1px 10px 40px rgb(0, 0, 0)) saturate(110%);
}

.CoverageFormat__margins {
  margin: 3rem;
}

@media (max-width: 768px) {
  .CoverageFormat__margins {
    margin: 1rem 0 1rem 0;
    text-align: left;
  }
}

.CoverageFormat__flag {
  width: 150px;
  border: 1px solid black;
}

@media (max-width: 768px) {
  .CoverageFormat section {
    -webkit-flex-direction: column;
    flex-direction: column;
  }
}
  </style>
  